import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AppBar, AppIcon, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { appImages } from "../../assets/appicons";
import { EMP_BASE_PATH } from "../../config";

const TEXT = "#08142D";

const MenuCard = ({ icon, label, onClick }) => (
  <Flex as="button" type="button" onClick={onClick} flex="1" direction="column" justify="space-between" h="96px" p="14px" borderRadius="12px" bg="white" border="1px solid" borderColor="#E5E9F0" textAlign="left" boxShadow="0px 5px 5px rgba(0,0,0,0.04)">
    <AppIcon src={icon} size={32} color={APP.primary200} />
    <Text fontSize="13px" fontWeight={600} color={TEXT}>{label}</Text>
  </Flex>
);

const BdcIndex = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const base = `${EMP_BASE_PATH}/tai-chinh/chung-chi-moi-gioi`;
  const menuCards = (
    <>
        <Flex gap="12px">
          <MenuCard icon={appImages.icon_TTKQ} label="Tạm giữ CCMG" onClick={() => navigate(`${base}/tam-giu`)} />
          <MenuCard icon={appImages.icon_HDMB} label="Lịch sử thanh toán CCMG" onClick={() => navigate(`${base}/giai-ngan`)} />
        </Flex>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Chứng chỉ môi giới" right={<DesktopBack onClick={() => navigate(EMP_BASE_PATH)} />}>
        <DesktopPanel>
          <Flex gap="16px" flexWrap="wrap" maxW="720px">
            {menuCards}
          </Flex>
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg="white" minH="100dvh">
      <AppBar title="Chứng chỉ môi giới" onBack={() => navigate(EMP_BASE_PATH)} />
      <Box px="16px" pt="12px">
        {menuCards}
      </Box>
    </Box>
  );
};

export default BdcIndex;
